export const calculateAgeStr = (birthDate: Date, deathDate: Date = new Date()): string => {
  const { years, months, days } = calculateFullAge(birthDate, deathDate)
  const d = `día${days !== 1 ? 's' : ''}`
  const m = `mes${months !== 1 ? 'es' : ''}`
  const a = `año${years !== 1 ? 's' : ''}`
  if (months === 0 && years === 0) {
    return `${days} ${d}`
  }
  else if (years === 0) {
    return `${months} ${m}`
  }
  return `${years} ${a}`
}

export const calculateAge = (birthDate: Date, deathDate: Date = new Date()): number => {
  if (birthDate > deathDate) {
    return 0
  }

  let age = deathDate.getFullYear() - birthDate.getFullYear()
  const monthDiff = deathDate.getMonth() - birthDate.getMonth()

  if (monthDiff < 0 || (monthDiff === 0 && deathDate.getDate() < birthDate.getDate())) {
    age--
  }

  return age
}

export const calculateAgeFullStr = (birthDate: Date, deathDate: Date = new Date()): string => {
  const { years, months, days } = calculateFullAge(birthDate, deathDate)
  const d = `día${days !== 1 ? 's' : ''}`
  const m = `mes${months !== 1 ? 'es' : ''}`
  const a = `año${years !== 1 ? 's' : ''}`
  if (months === 0 && years === 0) {
    return `${days} ${d}`
  }
  else if (years === 0) {
    return (months > 0 ? `${months} ${m}` : '') + (days > 0 ? `, ${days} ${d}` : '')
  }
  else {
    return `${years} ${a}` + (months > 0 ? `, ${months} ${m}` : '') + (days > 0 ? `, ${days} ${d}` : '')
  }
}

export const calculateFullAge = (birthDate: Date, deathDate: Date = new Date()): { years: number; months: number; days: number } => {
  if (birthDate > deathDate) {
    return { years: 0, months: 0, days: 0 }
  }

  let years = deathDate.getFullYear() - birthDate.getFullYear()
  let months = deathDate.getMonth() - birthDate.getMonth()
  let days = deathDate.getDate() - birthDate.getDate()

  if (days < 0) {
    months--
    const lastDayOfMonth = new Date(deathDate.getFullYear(), deathDate.getMonth(), 0).getDate()
    days += lastDayOfMonth
  }

  if (months < 0) {
    years--
    months += 12
  }

  return { years, months, days }
}